module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "queryForm",
    attrs: {
      "size": "mini",
      "inline": true,
      "label-position": "left",
      "label-width": _vm.queryFormLabelWidth,
      "model": _vm.queryForm
    }
  }, [(_vm.autocompleteData.schoolsList.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "学校名称",
      "prop": "commercial_id"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "school_name",
      "placeholder": "请输入",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'schoolsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('schoolsList', 2)
      },
      "select": function (item) { return _vm.handleSelect(item, 'schoolsList'); }
    },
    model: {
      value: (_vm.autocompleteData.school_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "school_name", $$v)
      },
      expression: "autocompleteData.school_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.autocompleteData.shopsList.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "店铺名称",
      "prop": "shop_id"
    }
  }, [_c('el-autocomplete', {
    attrs: {
      "clearable": "",
      "value-key": "shop_name",
      "placeholder": "请输入",
      "trigger-on-focus": false,
      "fetch-suggestions": function (query, cb) { return _vm.querySchoolSearch(query, cb, 'shopsList'); }
    },
    on: {
      "clear": function($event) {
        return _vm.clearSelect('shopsList', 2)
      },
      "select": function (item) { return _vm.handleSelect(item, 'shopsList'); }
    },
    model: {
      value: (_vm.autocompleteData.shop_name),
      callback: function($$v) {
        _vm.$set(_vm.autocompleteData, "shop_name", $$v)
      },
      expression: "autocompleteData.shop_name"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单日期",
      "prop": "dateType"
    }
  }, [_c('el-date-picker', {
    staticClass: "fl ml10",
    attrs: {
      "type": "daterange",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "placeholder": "请选择日期",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.queryForm.dateRange),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "dateRange", $$v)
      },
      expression: "queryForm.dateRange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fetchData
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('div', {
    staticClass: "doing"
  }, [_vm._v("友情提示：只能查询此功能上线之后(9月10号)的数据")])]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "border": ""
    }
  }, _vm._l((_vm.tableColumn), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "prop": item.id,
        "label": item.name,
        "show-overflow-tooltip": true,
        "width": item.width,
        "fixed": item.fixed
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.formatter) ? _c('span', [_vm._v(_vm._s(item.formatter(scope.row)))]) : _c('span', [_vm._v("\n                    " + _vm._s(scope.row[item.id]) + "\n                    "), (item.unit) ? _c('span', [_vm._v(_vm._s(item.unit))]) : _vm._e()])]
        }
      }], null, true)
    })
  }), 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.queryForm.pageNo,
      "page-sizes": _vm.pageSizes,
      "page-size": _vm.queryForm.pageSize,
      "layout": "total, sizes, prev, pager, next",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a2581aa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/headOffice/business/flow/list.vue
// module id = 878
// module chunks = 0